import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';

// components
import { SbSharedRefineMenuInputRangeCurrency } from '../../SbSharedRefineMenu/SbSharedRefineMenuInputRange/SbSharedRefineMenuInputRangeCurrency';

export const SbRespRefineMenuFilterPriceComponent = props => (
    <SbSharedRefineMenuInputRangeCurrency {...props} showInvalidRangeErrorMessage={false} />
);

export const SbRespRefineMenuFilterPrice = createFragmentContainer(
    SbRespRefineMenuFilterPriceComponent,
    {
        searchBrowse: graphql`
            fragment SbRespRefineMenuFilterPrice_searchBrowse on SearchBrowseQueryConnection {
                ...SbSharedRefineMenuInputRangeCurrency_searchBrowse
            }
        `,
    }
);
